import {gql} from 'apollo-angular';

export const RESET_SETTING = gql`
mutation resetSetting($key: String){
  resetSetting(key: $key)
}
`;

export const RESET_SETTING_LOCATION = gql`
mutation resetSetting($key: String, $locationId: UUID){
  resetSetting(key: $key, locationId: $locationId)
}
`;

export const UPDATE_SETTINGS = gql`
mutation updateSetting($settingInput: SettingInput){
  updateSetting(settingInput: $settingInput){
    id
  }
}
`;

export const UPDATE_USER_SETTINGS = gql`
mutation updateCurrentUsersSettings($userSettings: Map){
  updateCurrentUsersSettings(userSettings: $userSettings)
}
`;

export const GET_SETTING_QUERY = gql`
query getSetting($settingName: String) {
  getSetting(settingName: $settingName) {
    key
    label
    description
    type
    defaultValue
    currentValue
}
}
`;


